import axios from 'axios'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Col,
  Row
} from 'reactstrap'
import Success from '../../assets/abf/finish.jpg'
import Logo1 from '../../assets/abf/logo1.png'
import Logo2 from '../../assets/abf/logo2.png'
import config from '../../config/request.config'
import Auth from './Auth'
import {
  Button,
  ButtonSistema, ButtonsContainer,
  Container,
  Content, ErrorLabel, Form,
  FormGroup,
  ImageSize,
  Input,
  Label,
  Logo, TitleDiv
} from './style.styled'

const Prizedraw: React.FC = () => {
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({
    name: false,
    instagram: false,
    phone: false,
  });
  const [avisoPrivacidadeView, setAvisoPrivacidadeView] = React.useState(false);
  const [messageSuccess, setMessageSuccess] = React.useState(false);
  const [prizeDraw, setPrizeDraw] = React.useState(false);

  const generatorCode = () => { 
    // Obtenha a data e hora atual
    const now = new Date();

    // Gere um código numérico baseado na data/hora atual
    // Usando getTime(), que retorna o tempo em milissegundos desde 1970
    const codigo = now.getTime();

    // Converta o código para uma string para poder exibi-lo
    const codigoStr = codigo.toString();

    return Number(codigoStr)
  }

  const sendFormData = async (body: any) => {
    const user = localStorage.getItem('isAuthenticated')
    let formData = {
      oxCustom: body
    }
    formData.oxCustom.user = user?.toLowerCase()
    formData.oxCustom.code = generatorCode()
    try {
      await axios
        .post(`${config.HOST}:${config.PORT}/v1/subscription`, formData)
        .then((response) => {
          console.log("response: ", response);
          localStorage.setItem('oxCustom', "");
          setMessageSuccess(true)
        })
        .catch((error) => {
          alert("Ops, servidor desativado!");
          console.log("ERRRRRO: ", error.message);
        });
    } catch (error) {
      alert("Ops, servidor desativado!");
      console.log(123, `Erro: ${error}`);
    }
  };

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const newFormErrors = {
      name: false,
      instagram: false,
      phone: false,
    };

    if (!event.target) return;

    const form = event.target as HTMLFormElement;
    const nameInput = form.elements.namedItem('name') as HTMLInputElement;
    const instagramInput = form.elements.namedItem('instagram') as HTMLInputElement;
    const phone = form.elements.namedItem('phone') as HTMLInputElement;

    if (nameInput.value === '') {
      newFormErrors.name = true;
    }

    if (instagramInput.value === '') {
      newFormErrors.instagram = true;
    }

    if (phone.value === '') {
      newFormErrors.phone = true;
    }

    setFormErrors(newFormErrors);

    if (
      !newFormErrors.name &&
      !newFormErrors.instagram &&
      !newFormErrors.phone
    ) {
      const formData = {
        name: nameInput.value,
        instagram: instagramInput.value,
        phone: phone.value,
      };

      // Aqui você pode fazer algo com o objeto formData, como salvar em um arquivo JSON ou enviar para um servidor
      console.log('Form Data:', formData);      
      sendFormData(formData);
    }
  };
  
  return (
    <>
      <Container>
        {
          prizeDraw ? (<Auth setPrizeDraw={setPrizeDraw} />) : 
          messageSuccess ? (<><ImageSize src={Success} alt="Logo" onClick={() => {
            setMessageSuccess(false)
            setAvisoPrivacidadeView(false)
          }} /></>) : 
          !avisoPrivacidadeView ? (
            <Content>
              <Logo src={Logo1} alt="Logo" />
              <Logo src={Logo2} alt="Logo" />
              <Row>
                <Col md='6'>
                  <TitleDiv>
                    Ao utilizar esta aplicação, você concorda que coletamos e utilizamos o seu número de telefone exclusivamente para fins de comunicação relacionados aos nossos produtos e serviços. Garantimos a segurança e confidencialidade dos seus dados e não os compartilhamos com terceiros. Você pode solicitar o acesso ou exclusão dos seus dados a qualquer momento. Menores de idade devem obter consentimento dos pais ou responsáveis. Ao prosseguir, você concorda com nossa política de privacidade.
                  </TitleDiv>
                </Col>
              </Row>
              <br />
              <Row className='align-items-center'>
                <Col className='text-center' md={12}>
                  <Button
                    style={{
                      width: '80%',
                      height: '70px',
                      fontSize: '22px',
                      border: '2px solid #009999',
                      borderRadius: '50px',
                      backgroundColor: '#379583',
                      color: 'white',
                      marginTop: '15px'
                    }}
                    onClick={() => {
                      setAvisoPrivacidadeView(true);
                    }}
                  >
                    Li e concordo.
                  </Button>
                </Col>
              </Row>
            </Content>) : (
              <Content>
                <Logo src={Logo1} alt="Logo" />
                <Logo src={Logo2} alt="Logo" />
                <Form onSubmit={handleFormSubmit}>
                  <FormGroup>
                    <Label htmlFor="name">NOME:</Label>
                    <Input type="text" id="name" autoComplete="off" />
                    {formErrors.name && <ErrorLabel>Campo obrigatório</ErrorLabel>}
                    <Label htmlFor="instagram">INSTAGRAM:</Label>
                    <Input type="text" id="instagram" autoComplete="off" />
                    {formErrors.instagram && <ErrorLabel>Campo obrigatório</ErrorLabel>}
                    <Label htmlFor="phone">TELEFONE:</Label>
                    <Input type="text" id="phone" autoComplete="off" />
                    {formErrors.phone && <ErrorLabel>Campo obrigatório</ErrorLabel>}
                    {/* <Label htmlFor="profession">PROFISSÃO:</Label>
                    <Input type="text" id="profession" autoComplete="off" />
                    {formErrors.profession && (
                      <ErrorLabel>Campo obrigatório</ErrorLabel>
                    )} */}
                    <ButtonsContainer>
                      <Button>CADASTRAR</Button>
                      <ButtonSistema onClick={() => setPrizeDraw(true)}>SISTEMA</ButtonSistema>
                    </ButtonsContainer> 
                  </FormGroup>                                                   
                </Form>        
                    {/* <ButtonLogoff
                      onClick={() => {
                        localStorage.removeItem('isAuthenticated')
                        navigate('/login')
                    }}>
                      Deslogar
                    </ButtonLogoff> */}
              </Content>  
          )
        }
            
      </Container>      
    </>
  )
}

export default Prizedraw;